import { PaymentElement } from "@stripe/react-stripe-js";
import { PaymentIntent, StripeElements } from "@stripe/stripe-js";
import React, { useState, FC } from "react";

import * as config from "../../config";
import { fetchPostJSON } from "../../utils/api-helpers";

import {
  formatAmountForDisplay,
  // formatAmountFromStripe,
} from "../../utils/stripe-helpers";

const ElementsForm: FC<{
  paymentIntent?: PaymentIntent | null;
  elements?: StripeElements | null;
  payment: any;
  setPayment: any;
}> = ({ paymentIntent = null, elements = null, payment, setPayment }) => {
  const [paymentType, setPaymentType] = useState("");

  const PaymentStatus = ({ status }: { status: string }) => {
    switch (status) {
      case "processing":
      case "requires_payment_method":
      case "requires_confirmation":
        return <h2>Processing...</h2>;

      case "requires_action":
        return <h2>Authenticating...</h2>;

      case "succeeded":
        return <h2>Payment Succeeded 🥳</h2>;

      case "error":
        return <></>;

      default:
        return null;
    }
  };

  const handleInputChange: React.ChangeEventHandler<HTMLInputElement> = (e) =>
    setPayment({
      ...payment,
      [e.currentTarget.name]: e.currentTarget.value,
    });

  return (
    <>
      <fieldset className="elements-style">
        <div className="FormRow elements-style">
          <PaymentElement
            onChange={(e) => {
              setPaymentType(e.value.type);
            }}
          />
        </div>
      </fieldset>

      <div className="p-form__item mt-4">
        <p className="p-form__label">カード所有者名</p>
        {paymentType === "card" ? (
          <div className="p-form__input">
            <input
              placeholder="例) TAROU SHIMANE"
              className="elements-style"
              type="Text"
              name="cardholderName"
              onChange={handleInputChange}
              required
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default ElementsForm;
